import { render, staticRenderFns } from "./WorkflowPhases.vue?vue&type=template&id=a56659d2&scoped=true"
import script from "./WorkflowPhases.vue?vue&type=script&lang=js"
export * from "./WorkflowPhases.vue?vue&type=script&lang=js"
import style0 from "./WorkflowPhases.vue?vue&type=style&index=0&id=a56659d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56659d2",
  null
  
)

export default component.exports